import React, { useState } from 'react';
import { CheckboxChangeEvent, Col, Layout, Row, Typography, Form } from 'antd';
import { Input, Checkbox } from 'components';
import { ReactComponent as IconCheckmark } from 'static/icons/checkmark.svg';
import { ReactComponent as IconCheckmarkEmpty } from 'static/icons/checkmark_empty.svg';
import { useLang } from '../PlayerRegistration';
import './style.scss';

const PASSWORD_RULES = [
  {
    message: 'text_6_characters',
    error: 'error_less_6_char',
    regex: /^.{6,}$/,
  },
  {
    message: 'text_includes_uppercase',
    error: 'error_no_uppercase_letter',
    regex: /[A-Z]/,
  },
  {
    message: 'text_includes_numbers',
    error: 'error_no_numbers',
    regex: /[0-9]/,
  },
];

const PasswordChecks = ({ password = '' }: { password: string }) => {
  const { t } = useLang();

  return (
    <ul className="password-checker">
      {PASSWORD_RULES.map((check) => (
        <li key={check.message}>
          {check.regex.test(password) ? <IconCheckmark /> : <IconCheckmarkEmpty />}
          {t(check.message)}
        </li>
      ))}
    </ul>
  );
};

export const Step10 = () => {
  const { t } = useLang();
  const form = Form.useFormInstance();
  const password = Form.useWatch('password', form);
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Layout className="player-registration__step-10">
      <Row className="step-header">
        <Col span={24}>
          <Typography.Title level={4}>{t('subtitle_step_10')}</Typography.Title>
        </Col>
      </Row>
      <Row gutter={16} className="password-content">
        <Col span={24} md={{ span: 12 }}>
          <Input
            name="password"
            label={t('label_password')}
            type={showPassword ? 'text' : 'password'}
            rules={[
              {
                validator: (_, value) => {
                  if (!value) return Promise.reject(new Error(t('error_password')));
                  const failedRules = PASSWORD_RULES.filter((rule) => !rule.regex.test(value));
                  if (failedRules.length > 0) {
                    return Promise.reject(new Error(t(failedRules[0].error)));
                  }
                  return Promise.resolve();
                },
                required: true,
              },
            ]}
          />
          <Checkbox
            className="input-show-password"
            name="show-password"
            onChange={(e: CheckboxChangeEvent) => setShowPassword(e.target.checked)}
            formItemProps={{ valuePropName: 'checked' }}
          >
            {t('label_show_password')}
          </Checkbox>
        </Col>
        <Col span={24} md={{ span: 12 }}>
          <PasswordChecks password={password} />
        </Col>
      </Row>
    </Layout>
  );
};
